/**
 * Affiliates Data
 *
 * Organizational affiliations with logos and information
 */

import cnpLogo from '@/assets/Logo-council-for-national-policy.png'
import eagleCouncilLogo from '@/assets/Logo-phyllis-schlafly-eagle-council.jpeg'
import naclLogo from '@/assets/Logo-National-Association-of-Christian-Lawmakers.webp'
import alecLogo from '@/assets/Logo-American-Legislative-Exchange-Council.webp'
import type { Affiliate } from '@/components/sections/AffiliatesSection'

export const affiliatesContent: Affiliate[] = [
  {
    id: 'cnp',
    name: 'Council for National Policy',
    logo: cnpLogo,
    logoAlt: 'Council for National Policy logo',
    website: 'https://www.cfnp.org',
  },
  {
    id: 'eagle-council',
    name: 'Phyllis Schlafly Eagle Council',
    logo: eagleCouncilLogo,
    logoAlt: 'Phyllis Schlafly Eagle Council logo',
    website: 'https://www.phyllisschlafly.com',
  },
  {
    id: 'nacl',
    name: 'National Association of Christian Lawmakers',
    logo: naclLogo,
    logoAlt: 'National Association of Christian Lawmakers logo',
    website: 'https://christianlawmakers.com',
  },
  {
    id: 'alec',
    name: 'American Legislative Exchange Council',
    logo: alecLogo,
    logoAlt: 'American Legislative Exchange Council logo',
    website: 'https://alec.org',
  },
]
